import { EventBus } from '../plugins/event-bus.js'
import { ALL_REGIONS_TAG_ID } from '../util/constants.js'

// API UTIL
export const triggerAlert = (response) => {
  if (response?.data?.alert) {
    EventBus.$emit('triggerAlertResponse', response.data.alert)
  }
}

export const triggerErrorGeneric = () => {
  const alert = {
    status: 'error',
    message:
      'Something went wrong! Please refresh and try again, or contact the Careerwise team.',
  }

  EventBus.$emit('triggerAlertResponse', alert)
}

export const isSuccessResponse = (response) => {
  return !!response?.data?.success
}

// SHARED SETTINGS
export const mapSettings = (data) => {
  const settings = {
    ...data,
    // set pro plan flag
    isPro: data.plan > 2,
  }

  if (data.tag_regions) {
    const tag_regions = [...data.tag_regions].map((opt) => {
      if (opt.value === ALL_REGIONS_TAG_ID) {
        return {
          ...opt,
          textOptionsByCategory: {
            1: opt.text,
            2: 'Remote',
            3: 'Online',
          },
        }
      }

      return opt
    })

    settings.tag_regions = tag_regions
  }

  return settings
}

export const mapAdmin = (admin) => {
  return admin
    ? {
        ...admin,
        enable_connections_emails: !!admin.enable_connections_emails,
        enable_public_contact: !!admin.enable_public_contact,
      }
    : null
}

// CAREERWISE CONNECTIONS
export const mapTagsToVueFormulateObjects = (tags = []) => {
  return tags.map((opt) => {
    return {
      // @TODO might not need || if the wrapper fn is changed
      ...opt,
      value: opt.value || opt.id,
      label: opt.text || opt.title,
      description: opt.description || null,
    }
  })
}

export const mapConnection = (connection) => {
  return connection
    ? {
        ...connection,
        additional_info: JSON.parse(connection.additional_info),
        policeChecked: connection.local_police_checked,
      }
    : null
}

export const mapReport = (report, tagsGetter) => {
  const tagsMap = tagsGetter(report.tags)

  return report
    ? {
        ...report,
        ...tagsMap,
        additional_info: JSON.parse(report.additional_info),
      }
    : null
}

/**
 * Finds a tag from a list of tags by property 'value',
 * where value matches the given tag id (number or string).
 *
 * @param {array} tags full list of tags
 * @param {number|string} tagId id of tag to find
 * @returns {object} full tag object
 */
export const findTag = (tags, tagId) => {
  return tags.find((t) => t.value === parseInt(tagId))
}

// CAREERWISE CLOUD
export const mapCloudPostTags = (tags, tag_titles) => {
  return tags
    ?.filter((tag) => {
      return tag_titles.includes(tag.text)
    })
    .map((tag) => tag.text)
}

// CAREERWISE MAIL
export const mapList = (list) => {
  return {
    id: list.id,
    name: list.name,
    address: list.sending_address || '',
    createdAt: list.created_at || null,
    updatedAt: list.updated_at || null,
    hailListId: list.hail_list_id || null,
  }
}

export const mailTypes = {
  careerwise: 'careerwise',
  hero: 'hero',
  hail: 'hail',
}

export const reduceListsHail = (acc, list) => {
  const blackList = [mailTypes.careerwise, mailTypes.hero]

  // omit Careerwise, Hero, etc. lists
  if (
    !blackList.includes(list.sms_type) &&
    !blackList.includes(list.integration_provider)
  ) {
    // Hail list if both sms type and integration provider are null
    const isHail = !list.sms_type && !list.integration_provider
    const type = isHail ? mailTypes.hail : list.sms_type

    const listMapped = mapListHail(list, type)

    if (!acc[type]) {
      acc[type] = []
    }

    acc[type].push(listMapped)
  }

  return acc
}

export const mapListHail = (list, type) => {
  return {
    id: list.id,
    type,
    name: list.name,
    address: list.sending_address || '',
    updatedAt: list.last_updated || null,
    hailListId: list.id || null,
    subscribers: list.contact_details.map((contact, index) => {
      const status = contact.bounced
        ? 'bounced'
        : contact.complained
        ? 'unsubscribed'
        : 'subscribed'
      return {
        id: index,
        selected: null,
        email: contact.email,
        status,
        createdAt: null,
        lists: null,
        actions: false,
      }
    }),
    actions: false,
  }
}

export const mapFollower = (follower, status) => {
  return {
    id: follower.id,
    selected: false,
    showBulkActions: false,
    email: follower.email,
    createdAt: follower.unix_created_at * 1000 || 0,
    status,
    lists: follower.mail_lists?.map((list) => mapList(list)) || [],
    actions: true,
  }
}

export default {
  triggerAlert,
  triggerErrorGeneric,
  isSuccessResponse,
  mapCloudPostTags,
  mapList,
  mailTypes,
  reduceListsHail,
  mapListHail,
  mapFollower,
}
